import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Subject } from 'rxjs';
import { Initials } from '../../models/initials.model';
import { ShellFacadeService } from '../shell/shell-facade.service';

@Injectable()

export class ResolverService implements Resolve<Promise<Initials>> {
    private resolvedInfo: Initials;
    public updateInitInfo = new Subject<boolean>();

    public constructor(
        private shellFacadeService: ShellFacadeService
    ) { }

    private resolveInfo(notify:boolean = false): Promise<Initials> {
        return new Promise((resolve, reject) => {
            this.shellFacadeService.getShellInitial().subscribe(
                data => {
                    this.userInitInfo = data;
                    resolve(data)
                    if(notify) {
                        this.updateInitInfo.next(true);
                    }
                }, error => {
                    reject();
                }
            )
        })
    }

    get userInitInfo() {
        return this.resolvedInfo;
    }

    set userInitInfo(info) {
        this.resolvedInfo = info;
    }

    public updateInfo() {
        this.resolveInfo(true);
    }

    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Initials> {
        return this.resolveInfo();
    }


}
